import { textStyles } from '../../../theme/common';
import {
  Flex,
  Heading,
  Icon,
  IconButton,
  IconName,
  Stack,
  StackProps,
  Subtitle
} from '../../atoms';

type Props = StackProps & {
  title?: string;
  subtitle?: string;
  icon?: JSX.Element;
  backFct?: () => void;
};

export function OverviewPageHeader({
  title,
  subtitle,
  children,
  icon,
  backFct,
  ...rest
}: Props): JSX.Element {
  return (
    <Stack
      direction={['column', 'column', 'row']}
      alignItems="center"
      justifyContent="space-between"
      marginBottom="space_unit.x4"
      {...rest}
    >
      <Stack direction="column">
        <Flex alignItems="center" justifyContent="left">
          {backFct && (
            <IconButton
              onClick={backFct}
              variant="tertiary"
              aria-label="back-button"
              icon={<Icon w="18px" name={IconName.ArrowBack} />}
              mr="space_unit.x1"
            />
          )}
          {icon && <Flex mr="space_unit.x1">{icon}</Flex>}
          <Heading as="h1" variant="h3" data-testid="heading-company-insights">
            {title}
          </Heading>
        </Flex>

        {subtitle && (
          <Subtitle {...textStyles.bodyCapital}>{subtitle}</Subtitle>
        )}
      </Stack>
      {children}
    </Stack>
  );
}
